export default __webpack_public_path__ + "static/media/TOUCH_LOCAL.527ebe9e.png";